var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "NestedMenu",
    {
      attrs: {
        title: "Choose how you want to boss your fries",
        platform: "kiosk"
      }
    },
    [
      _c(
        "ProductMenuInlineLayout",
        _vm._l(_vm.products, function(product) {
          return _c("ProductCard", {
            key: product.title,
            attrs: { product: product },
            on: { click: product.onClick }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskFriesMenu.vue?vue&type=template&id=e8cd0720&
// module id = null
// module chunks = 